document.addEventListener('DOMContentLoaded', function() {
  // Event listener for product spec button
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('btn-product-spec') || e.target.closest('.btn-product-spec')) {
      const button = e.target.classList.contains('btn-product-spec') ? e.target : e.target.closest('.btn-product-spec');
      
      // Get the data attributes
      const dataStoreId = button.getAttribute('data-storeId');
      const dataHandle = button.getAttribute('data-handle');
      const dataProductId = button.getAttribute('data-productId');
      
      // Create and show modal
      showProductSpecsModal(dataStoreId, dataHandle);
    }
  });
  
  // Event listener for assembly instructions button
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('btn-assembly') || e.target.closest('.btn-assembly')) {
      const button = e.target.classList.contains('btn-assembly') ? e.target : e.target.closest('.btn-assembly');
      
      // Get the data attributes
      const dataStoreId = button.getAttribute('data-storeId');
      const dataHandle = button.getAttribute('data-handle');
      
      // Create and show modal
      showAssemblyModal(dataStoreId, dataHandle);
    }
  });
  
  // Event delegation for file download clicks (for elements added dynamically)
  document.addEventListener('click', function(e) {
    const fileCell = e.target.closest('.divArchitectImgsCellInner');
    if (fileCell) {
      const fileUrl = fileCell.getAttribute('data-url');
      if (fileUrl) {
        window.open(fileUrl, '_blank'); // Open in a new tab
        //window.location.href = fileUrl;
      }
    }
  });
  
  function showProductSpecsModal(dataStoreId, dataHandle) {
    // Create modal if it doesn't exist
    let modal = document.getElementById('product-specs-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'product-specs-modal';
      modal.className = 'modal-overlay';
      modal.innerHTML = `
        <div class="modal-content">
          <div class="modal-header">
            <h3>Product Specifications</h3>
            <span class="close-modal">&times;</span>
          </div>
          <div class="confirm-modal-body">
            <p>Loading product specifications...</p>
          </div>
        </div>
      `;
      document.body.appendChild(modal);
      
      // Add close functionality
      modal.querySelector('.close-modal').addEventListener('click', function() {
        modal.style.display = 'none';
      });
      
      // Close modal when clicking outside
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          modal.style.display = 'none';
        }
      });
    }
    
    // Show the modal
    modal.style.display = 'block';
    modal.querySelector('.confirm-modal-body').innerHTML = '<p>Loading product specifications...</p>';
    
    // Make the AJAX request
    fetch('/apps/dp/product-specs/product-specs-files?storeId=' + dataStoreId + '&handle=' + dataHandle, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data.msgtype === 'success') {
        const files = data.files;
        let html = '';
        
        for(let n=0; n < files.length; n++) {
          const fileType = files[n].file_type ? files[n].file_type : files[n].file_url.substr(files[n].file_url.lastIndexOf('.') + 1);
          html += `<div class="divArchitectImgsCell">
            <div class="divArchitectImgsCellInner" data-url="${files[n].file_url}">
              <div class="divArchitectImgsCellImage">
                <span class="fileType">${fileType}</span>
                <span class="downloadText">Download <i class="fa fa-download" aria-hidden="true"></i></span>
              </div>
              <div class="divArchitectImgsCellName">${files[n].name}</div>
            </div>
          </div>`;
        }
        
        modal.querySelector('.confirm-modal-body').innerHTML = html;
      } else {
        modal.querySelector('.confirm-modal-body').innerHTML = data.msg;
      }
    })
    .catch(error => {
      modal.querySelector('.confirm-modal-body').innerHTML = '<p>Error loading product specifications. Please try again.</p>';
      console.error('Error fetching product specs:', error);
    });
  }
  
  function showAssemblyModal(dataStoreId, dataHandle) {
    // Create modal if it doesn't exist
    let modal = document.getElementById('assembly-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'assembly-modal';
      modal.className = 'modal-overlay';
      modal.innerHTML = `
        <div class="modal-content">
          <div class="modal-header">
            <h3>Assembly Instructions</h3>
            <span class="close-modal">&times;</span>
          </div>
          <div class="confirm-modal-body">
            <p>Loading assembly instructions...</p>
          </div>
        </div>
      `;
      document.body.appendChild(modal);
      
      // Add close functionality
      modal.querySelector('.close-modal').addEventListener('click', function() {
        modal.style.display = 'none';
      });
      
      // Close modal when clicking outside
      modal.addEventListener('click', function(e) {
        if (e.target === modal) {
          modal.style.display = 'none';
        }
      });
    }
    
    // Show the modal
    modal.style.display = 'block';
    modal.querySelector('.confirm-modal-body').innerHTML = '<p>Loading assembly instructions...</p>';
    
    // Make the AJAX request - adjust the URL if needed based on your discovery
      fetch('/apps/dp/Symbols/assembly_files?storeId=' + dataStoreId + '&handle=' + dataHandle, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(data => {
      if(data.msgtype === 'success') {
        const files = data.files;
        let html = '';
        
        for(let n=0; n < files.length; n++) {
          const fileType = files[n].file_type ? files[n].file_type : files[n].file_url.substr(files[n].file_url.lastIndexOf('.') + 1);
          html += `<div class="divArchitectImgsCell">
            <div class="divArchitectImgsCellInner" data-url="${files[n].file_url}">
              <div class="divArchitectImgsCellImage">
                <span class="fileType">${fileType}</span>
                <span class="downloadText">Download <i class="fa fa-download" aria-hidden="true"></i></span>
              </div>
              <div class="divArchitectImgsCellName">${files[n].name}</div>
            </div>
          </div>`;
        }
        
        modal.querySelector('.confirm-modal-body').innerHTML = html;
      } else {
        modal.querySelector('.confirm-modal-body').innerHTML = data.msg;
      }
    })
    .catch(error => {
      modal.querySelector('.confirm-modal-body').innerHTML = '<p>Error loading assembly instructions. Please try again.</p>';
      console.error('Error fetching assembly instructions:', error);
    });
  }
});